import React from "react";
import { useTranslation } from "react-i18next";
import { EditOutlined, DeleteOutlined } from "us.icons";

interface IItemMenu {
  actions?: [];
  onCallAction: (actionType: string) => void;
}

/**
 * @description - USC Section menu
 * @author Roshan Maddumage <roshanma@unicorn-solutions.com>
 * @since 06/01/2023
 */
const ItemMenu: React.FC<IItemMenu> = (props) => {
  const { t } = useTranslation();
  const { actions, onCallAction } = props;

  return (
    <div className="table-more-content" data-testid="popover-content">
      <div
        className="d-flex  flex-row more-item"
        data-testid="edit-btn"
        onClick={() => onCallAction("edit")}
      >
        <div className="p-1">
          <EditOutlined />
        </div>
        <div className="p-1">{t("US.COMMON:COMMON.EDIT")}</div>
      </div>

      <div
        className="d-flex  flex-row text-error more-item"
        data-testid="copy-btn"
        onClick={() => onCallAction("delete")}
      >
        <div className="p-1">
          <DeleteOutlined />
        </div>
        <div className="p-1">{t("US.COMMON:COMMON.DELETE")}</div>
      </div>
    </div>
  );
};

export default ItemMenu;
